export default "__VITE_ASSET__r6OxJbff__"